import { render } from "./ThirdWaveAccessMenuPage.vue?vue&type=template&id=5bee06c0&scoped=true&ts=true"
import script from "./ThirdWaveAccessMenuPage.vue?vue&type=script&lang=ts"
export * from "./ThirdWaveAccessMenuPage.vue?vue&type=script&lang=ts"

import "./ThirdWaveAccessMenuPage.vue?vue&type=style&index=0&id=5bee06c0&scoped=true&lang=scss"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bee06c0"]])

export default __exports__